import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, Check, Phone, MessageCircle } from "lucide-react";
import { ProductImages } from "../assets/ProductImages";
import { getKitItems } from "../data/products";

export default function ProductModal({ product, onClose }) {
  const ImageComponent = product && ProductImages[product.imageType];
  const kitItems = product?.isKit ? getKitItems(product) : [];

  return (
    <AnimatePresence>
      {product && (
        <motion.div
          className="modal-backdrop"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClose}
        >
          <motion.div
            className="modal-panel"
            initial={{ opacity: 0, y: 60, scale: 0.97 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 40, scale: 0.97 }}
            transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
            onClick={(e) => e.stopPropagation()}
            style={{ "--accent": product.accent }}
          >
            <button className="modal-close" onClick={onClose}><X size={20} /></button>

            <div className="modal-inner">
              <div className="modal-media">
                <div className="modal-image" style={{ background: product.color }}>
                  {product.image ? (
                    <img src={product.image} alt={product.name} className="modal-photo" />
                  ) : (
                    ImageComponent && <ImageComponent accent={product.accent} />
                  )}
                  <div className="modal-tag" style={{ color: product.accent }}>
                    {product.tag}
                  </div>
                </div>

                <div className="modal-contact-panel">
                  <p className="modal-contact-prompt">
                    Every situation is different. Contact our team for guidance and a quote tailored to your needs.
                  </p>

                  <div className="modal-actions">
                    <a
                      href="tel:+9779716886567"
                      className="modal-btn-primary"
                      style={{ background: product.accent, color: "#fff" }}
                    >
                      Contact Us
                    </a>
                    <a
                      href={`https://wa.me/9779716886567?text=${encodeURIComponent(`Hello MedEase Nepal, I would like to inquire about ${product.name}.`)}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="modal-btn-whatsapp"
                    >
                      <MessageCircle size={16} /> WhatsApp
                    </a>
                  </div>

                  <div className="modal-contact-note">
                    <Phone size={12} />
                    <span>Call us at <a href="tel:+9779716886567">+977 971-688-6567</a></span>
                  </div>
                </div>
              </div>

              <div className="modal-content">
                <div className="modal-category">{product.category.toUpperCase()} COLLECTION</div>
                <h2 className="modal-name">{product.name}</h2>
                <p className="modal-subtitle">{product.subtitle}</p>

                <div className="modal-divider" style={{ background: product.accent }} />

                <p className="modal-desc">{product.description}</p>

                {product.isKit && kitItems.length > 0 && (
                  <div className="modal-kit-includes">
                    <div className="features-title">SET INCLUDES</div>
                    {kitItems.map((item) => (
                      <div key={item.name} className="modal-kit-include-row">
                        <Check size={13} style={{ color: product.accent, flexShrink: 0 }} />
                        <span className="modal-kit-include-name">
                          {item.name}
                          {item.subtitle && (
                            <span className="modal-kit-include-subtitle"> — {item.subtitle}</span>
                          )}
                        </span>
                      </div>
                    ))}
                  </div>
                )}

                <div className="modal-features">
                  <div className="features-title">KEY FEATURES</div>
                  {product.features.map((f, i) => (
                    <motion.div
                      key={f}
                      className="feature-row"
                      initial={{ opacity: 0, x: -10 }}
                      animate={{ opacity: 1, x: 0 }}
                      transition={{ delay: 0.1 + i * 0.07 }}
                    >
                      <Check size={13} style={{ color: product.accent, flexShrink: 0 }} />
                      <span>{f}</span>
                    </motion.div>
                  ))}
                </div>
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
